import styled, { css } from 'styled-components';
import { getSizeBy, getFontFamily, getTypography, getThemePropOrElse } from '../../../src/styled/utils';
import mixins from './mixins';
/**
 * `Heading1` is a styled-component that applies typography styles for a level 1 heading.
 *
 * It uses the `Heading1Styles` for basic typography styles and applies additional styles based on the theme.
 *
 * @component
 * @example
 * // Usage example
 * <Heading1>This is a level 1 heading</Heading1>
 *
 * @param {object} props - The properties that define the styled component.
 * @param {object} props.theme - The theme object from styled-components.
 * @returns {React.ElementType} A styled-component that can be used as a React component.
 */
export const Heading1Styles = css `
  font-weight: ${getThemePropOrElse(['typography', 'Heading1', 'fontWeight'], 600)};
  font-size: ${getThemePropOrElse(['typography', 'Heading1', 'fontSize'], getSizeBy(6.5))};
  font-family: ${getFontFamily('secondary')};
  line-height: ${getSizeBy(8)};
  letter-spacing: ${getSizeBy(-0.04)};
`;
const TextElement = styled.h1 `
  ${mixins}
  ${Heading1Styles}
`;
export const Heading1 = styled(TextElement)({}, ({ theme }) => getTypography('Heading1')({ theme }));
